import React from 'react';
import { useFormState } from 'react-final-form';
import { useIntl } from 'react-intl';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { useCountryConfigContext } from 'modules/country/CountryConfigContext';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { DiscountFields } from './DiscountFields';
import { useRowOverrideContext } from './WithOverrideToggle';
import { BaseField } from './types';
import { useOfferOverridesContext } from '../../../context/OfferOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText, StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

export const Discount = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { currency } = useCountryConfigContext();
  const { maybeOverriddenOffer, getOfferAttrHasOverride } = useOfferOverridesContext();

  const { isOverrideToggleOn, isRowGroupEnabledForOverride } = useRowOverrideContext();

  const isDiscountOverridden = getOfferAttrHasOverride('discounted');
  const discountTypeFieldNameToUse: keyof FormValues = isOverrideToggleOn ? 'discountTypeOverride' : 'discountType';
  const offerToUse = isOverrideToggleOn ? maybeOverriddenOffer : offer;

  const displayField = (
    <DisplayText>
      {offerToUse?.discounted ? <MonetaryAmount currency={currency} amount={offerToUse.price} /> : '-'}
    </DisplayText>
  );

  const editField = (
    <StyledInputContainer>
      <DiscountFields
        disabled={false}
        currency={currency}
        isWeightedItem={values.weightType === 'weighted-items'}
        isOverrideToggleOn={isOverrideToggleOn}
      />
    </StyledInputContainer>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.discount' })}
      previewComponent={displayField}
      editComponent={editField}
      shouldDisplayCreateTag={!values[discountTypeFieldNameToUse]}
      sidePanelMode={sidePanelMode}
      offer={offer}
      isOverridden={isDiscountOverridden}
      canBeOverridden={isRowGroupEnabledForOverride}
    />
  );
};
